<template>
  <section class="h-100">

    <div class="m-auto text-center mb-7">
      <img
        src="@/assets/images/menu_2.svg"
        class="w-full"
      >

      <img
        src="@/assets/images/setup_profile/step_5.svg"
        class="mx-auto mt-5"
      >
      <span class="text-neutral">Step 5 of 10</span>
    </div>

    <div class="flex h-screen text-center" style="height: 80vh;">

      <div class="m-auto pb-10 w-2/3">

        <div class="mt-9">
          <h3 class="text text-center text-black mb-4">
            Places {{ firstName }} has lived
          </h3>

          <a href="#" class="text-primary font-bold">Where did you get this information?</a>
        </div>

        <div v-if="!editable">

          <div class="h-56 grid grid-cols-4 justify-center content-center place-items-center">

            <div class="text-center mb-5" v-for="place in places" :key="place.node_uuid">
              <img
                src="@/assets/images/undraw/walk_in_the_city.svg"
                class="mx-auto mb-3"
              >

              <span class="text text-black">
                <strong>{{ place.city }},</strong> {{ place.state }}
              </span>
            </div>
          </div>

          <div class="mt-5">
            <router-link
              :to="{name: 'v2.profile.education'}"
              class="text-primary float-left"
            >
              <img
                src="@/assets/images/icons/ic_chevron_left_blue.svg"
                class="inline"
              >
              Back
            </router-link>

            <a
              href="#"
              class="btn btn-primary-outline btn-large align-self-center me-auto mr-5"
              @click="changeMode()"
            >
              Edit
            </a>

            <router-link
              :to="{name: 'v2.profile.great_job'}"
              class="btn btn-primary btn-large align-self-center me-auto"
            >
              Looks Good!
            </router-link>

            <router-link
              :to="{name: 'v2.profile.great_job'}"
              class="text-primary float-right"
            >
              Skip

              <img
                src="@/assets/images/icons/ic_chevron_right_blue.svg"
                class="inline"
              >
            </router-link>
          </div>
        </div>

        <div v-if="editable">
          <form
            class="mt-10 mb-10"
            @submit.prevent="register"
          >

            <div
              v-if="errorMessage"
              class="flex items-center text-dark text-sm mb-5 alert-error"
              role="alert"
            >
              <img
                src="@/assets/images/ic_danger.svg"
                class="mr-2"
              >
              <p>{{ errorMessage }}</p>
            </div>

            <div class="mb-10">
              <div class="form-check w-1/2 inline-block text-right">
                <label class="form-check-label" for="flexCheckIndeterminate">
                  Show
                </label>

                <label class="switch">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <div class="mb-10">
              <input
                v-model="country"
                type="text"
                class="form-control w-1/2"
                placeholder="Country"
                required
              >
            </div>

            <div class="mb-10">
              <input
                v-model="city"
                type="text"
                class="form-control"
                placeholder="City"
                style="width: 23.3%;margin-right: 40px;"
                required
              >

              <input
                v-model="state"
                type="text"
                class="form-control w-1/4"
                placeholder="State"
                style="width: 23.3%;"
                required
              >
            </div>

            <div class="mb-10">
              <input
                v-model="from"
                type="text"
                class="form-control"
                placeholder="From"
                style="width: 23.3%;margin-right: 40px;"
                required
              >

              <input
                v-model="until"
                type="text"
                class="form-control w-1/4"
                placeholder="Until"
                style="width: 23.3%;"
                required
              >
            </div>

            <div class="mb-10">
              <div class="form-check w-1/2 inline-block">
                <label class="form-check-label text-neutral float-left" for="flexCheckIndeterminate">
                  I was born here
                </label>

                <label class="switch float-right">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <div class="mb-10">
              <div class="form-check w-1/2 inline-block">
                <label class="form-check-label text-neutral float-left" for="flexCheckIndeterminate">
                  I currently live here
                </label>

                <label class="switch float-right">
                  <input type="checkbox" checked>
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <div class="mb-6">
              <textarea
                v-model="description"
                rows="4"
                cols="10"
                class="w-1/2 p-2"
                placeholder="What I love about it"
              ></textarea>
            </div>
          </form>

          <div class="mb-10">
            <a
              href="#"
              class="text-primary align-self-center me-auto"
            >
              Add Another

              <img
                src="@/assets/images/icons/ic_plus.svg"
                class="inline-block"
              >
            </a>
          </div>

          <div class="mt-5">
            <router-link
              :to="{name: 'v2.profile.education'}"
              class="text-primary float-left"
            >
              <img
                src="@/assets/images/icons/ic_chevron_left_blue.svg"
                class="inline"
              >
              Back
            </router-link>

            <a
              href="#"
              @click="changeMode()"
              class="btn btn-primary-outline btn-large align-self-center me-auto mr-5"
            >
              Finish Later
            </a>

            <a
              href="#"
              @click="submit()"
              class="btn btn-primary btn-large align-self-center me-auto"
            >
              Onwards
            </a>

            <router-link
              :to="{name: 'v2.profile.great_job'}"
              class="text-primary float-right"
            >
              Skip

              <img
                src="@/assets/images/icons/ic_chevron_right_blue.svg"
                class="inline"
              >
            </router-link>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Places',
  data() {
    return {
      firstName: '',
      country: '',
      city: '',
      state: '',
      date_from: '',
      date_until: '',
      born_here: false,
      currently_living: false,
      description: '',
      errorMessage: null,
      editable: false,
      places: [],
      uuid: null
    };
  },
  methods: {
    changeMode: function() {
      this.editable = !this.editable;
    },
    getPlaces() {
      axios.get(process.env.VUE_APP_API_URL + '/attributes/place/' + this.uuid, {
        headers: {
          'Authorization': `Bearer`
        }
      })
      .then((response) => {
        this.places = response.data.attributes;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    submit() {
      let data = {
        uuid: this.uuid,
        node_type: 'place',
        attributes: {
          country: this.country,
          city: this.city,
          state: this.state,
          date_from: this.date_from,
          date_until: this.date_until,
          born_here: this.born_here,
          currently_living: this.currently_living,
          description: this.description
        }
      };

      axios.post(process.env.VUE_APP_API_URL + '/attribute', data, {
        headers: {
          'Authorization': `Bearer`
        },
      })
      .then((response) => {
        console.log(response);
        
        this.changeMode();
        this.getPlaces();
      })
      .catch((error) => {
        console.log(error);
      });
    }
  },
  mounted() {
    let firstName = localStorage.getItem('preferredname');
    this.uuid = localStorage.getItem('userUuid');

    if (firstName && firstName !== '') {
      this.firstName = firstName;
    }

    this.getPlaces();
  }
}
</script>

<style scoped>
h3 {
  font-family: 'Helvetica';
  font-size: 30px;
  line-height: 32px;
  letter-spacing: 1px;
  font-weight: bold;
}
h3 > strong {
  font-weight: bold;
}
</style>
